import { render, staticRenderFns } from "./IncentivosClienteIntegral.vue?vue&type=template&id=398f5bcd"
import script from "./IncentivosClienteIntegral.vue?vue&type=script&lang=js"
export * from "./IncentivosClienteIntegral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports